const Hero = () => {
  return (
    <section className="hero-section" id="home" data-testid="hero-section">
      <div className="hero-grid">
        <div className="hero-content">
          <span className="hero-badge" data-testid="hero-badge">
            🌿 MCIM Registered · Nala Sopara, Maharashtra
          </span>

          <h1 className="hero-headline" aria-label="Heal at the Root. Where Nadi Parikshan Tells Your Story Before You Speak.">
            <span className="hero-line-1">Heal at the Root.</span>
            <span className="hero-line-2">Where Nadi Parikshan Tells</span>
            <span className="hero-line-3">Your Story Before You Speak.</span>
          </h1>

          <p className="hero-sub">
            Ancient Ayurvedic science. Modern clinical expertise. Real patient results.
          </p>

          <div className="hero-ctas">
            <a href="tel:+919028923930" className="btn-primary" data-testid="call-now-btn">
              📞 Call Now — 90289 23930
            </a>
            <a
              href="https://wa.me/919028923930?text=Hello%20Siddhayu%20Ayurvedic%20Clinic!%20I%20found%20your%20website%20and%20would%20like%20to%20book%20a%20consultation."
              className="btn-secondary"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-hero-btn"
            >
              💬 WhatsApp Us
            </a>
          </div>

          <div className="hero-rating" data-testid="hero-rating">
            ⭐ 4.9 Google Rating
          </div>
        </div>

        <div className="hero-image-wrap" data-testid="hero-image-wrap">
          <img
            src="/hero-ayurveda.webp"
            alt="Authentic Ayurvedic herbs, oils and Nadi Parikshan tradition at Siddhayu Clinic"
            className="hero-image"
            loading="eager"
            fetchPriority="high"
            decoding="async"
            width="480"
            height="280"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
